import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  standalone: false,
    selector: 'app-override-srd-policy-modal',
    templateUrl: './override-srd-policy-modal.component.html',
    styleUrls: ['./override-srd-policy-modal.component.css']
})
export class OverrideSrdPolicyModalComponent {

    constructor(public activeModal: NgbActiveModal) {}

    cancel(): void {
        this.activeModal.dismiss();
    }

    confirm(): void {
        this.activeModal.close(true);
    }
}
